module.exports = __webpack_public_path__ + "static/footer-cta-2e640192c47ba250d7db0cdd0d97ae65.jpg";